import { numberFormatAsString } from "commons/ultilities";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { IWorkOrderPo } from "mobx-stores/_models/work-order-po/work-order-po";
import { useMemo } from "react";
import { ElementToPrint } from "share-components/templates/print/element";
import { TEXT_PRINT_COLOR, TEXT_PRINT_FONT_WEIGHT } from "../const";

export const useBackPage2Elements = ({
  workOrderPoDetail,
}: {
  workOrderPoDetail: IWorkOrderPo;
  fontWeight?: number | string | undefined;
}) => {
  const foilProgress = workOrderPoDetail?.foilProgress;
  const shapeProgress = workOrderPoDetail?.shapeProgress;
  const pasteProgress = workOrderPoDetail?.pasteProgress;
  const cutProgress = workOrderPoDetail?.cutProgress;
  const packageProgress = workOrderPoDetail?.packageProgress;

  const foilStandardDisplay = workOrderPoDetail?.foilStandardDisplay;
  const shapeStandardDisplay = workOrderPoDetail?.shapeStandardDisplay;
  const pasteStandardDisplay = workOrderPoDetail?.pasteStandardDisplay;
  const cutStandardDisplay = workOrderPoDetail?.cutStandardDisplay;
  const packagesStandardDisplay = workOrderPoDetail?.packageStandardDisplay;
  const backPage2Elements = useMemo<ElementToPrint[]>(() => {
    const elements: ElementToPrint[] = [
      {
        name: "newElement1",
        value: foilStandardDisplay?.standard || "",
        top: "1.42cm",
        left: "4.60cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "15.48cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement2",
        value: dateTimeDisplay(foilProgress?.date) || "",
        top: "2.13cm",
        left: "3.88cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "3.07cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement3",
        value: foilProgress?.operator || "",
        top: "2.14cm",
        left: "10.45cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "3.12cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement4",
        value: foilProgress?.equipment || "",
        top: "2.16cm",
        left: "17.33cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "3.18cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement5",
        value: dateTimeDisplay(foilProgress?.completedDate) || "",
        top: "2.83cm",
        left: "4.39cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.62cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement7",
        value: foilProgress?.inspector || "",
        top: "2.86cm",
        left: "17.33cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "3.18cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement8",
        value: numberFormatAsString(
          foilProgress?.printPaperAmount?.toString() || "",
        ),
        top: "3.53cm",
        left: "3.62cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "1.67cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement9",
        value: numberFormatAsString(foilProgress?.amount?.toString() || ""),
        top: "3.55cm",
        left: "9.14cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.54cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement12",
        value: numberFormatAsString(
          foilProgress?.lossPercent?.toString() || "",
          {
            decimalScale: 2,
          },
        ),
        top: "4.23cm",
        left: "18.46cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "1.72cm",
        textWrap: "nowrap",
        textAlight: "center",
      },
      {
        name: "newElement13",
        value: numberFormatAsString(
          foilProgress?.printPaperCompletedAmount?.toString() || "",
        ),
        top: "4.25cm",
        left: "3.21cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.04cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement14",
        value: numberFormatAsString(
          foilProgress?.completedAmount?.toString() || "",
        ),
        top: "4.26cm",
        left: "9.11cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.62cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement15",
        value: numberFormatAsString(foilProgress?.lossAmount?.toString() || ""),
        top: "4.25cm",
        left: "14.66cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "1.53cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement16",
        value: foilStandardDisplay?.note || "",
        top: "4.95cm",
        left: "2.63cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "17.67cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement17",
        value: shapeStandardDisplay?.standard || "",
        top: "6.45cm",
        left: "4.39cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "15.72cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement18",
        value: dateTimeDisplay(shapeProgress?.date) || "",
        top: "7.21cm",
        left: "3.84cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "3.15cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement19",
        value: shapeProgress?.operator || "",
        top: "7.19cm",
        left: "10.42cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "3.12cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement20",
        value: shapeProgress?.equipment || "",
        top: "7.16cm",
        left: "17.39cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.86cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement21",
        value: dateTimeDisplay(shapeProgress?.completedDate) || "",
        top: "7.86cm",
        left: "4.26cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.59cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement23",
        value: shapeProgress?.inspector || "",
        top: "7.89cm",
        left: "17.39cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.80cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement24",
        value: numberFormatAsString(
          shapeProgress?.printPaperAmount?.toString() || "",
        ),
        top: "8.59cm",
        left: "3.72cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.14cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement25",
        value: numberFormatAsString(shapeProgress?.amount?.toString() || ""),
        top: "8.61cm",
        left: "9.74cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.38cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement28",
        value: numberFormatAsString(
          shapeProgress?.printPaperCompletedAmount?.toString() || "",
        ),
        top: "9.28cm",
        left: "3.22cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.57cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement29",
        value: numberFormatAsString(
          shapeProgress?.completedAmount?.toString() || "",
        ),
        top: "9.30cm",
        left: "9.74cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.35cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement30",
        value: numberFormatAsString(
          shapeProgress?.lossAmount?.toString() || "",
        ),
        top: "9.29cm",
        left: "15.01cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "1.83cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement31",
        value: numberFormatAsString(
          shapeProgress?.lossPercent?.toString() || "",
          {
            decimalScale: 2,
          },
        ),
        top: "9.25cm",
        left: "19.18cm",
        fontSize: "16px",
        height: "0.77cm",
        width: "1.14cm",
        textWrap: "nowrap",
        textAlight: "center",
      },
      {
        name: "newElement32",
        value: shapeStandardDisplay?.note || "",
        top: "9.98cm",
        left: "2.68cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "17.83cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement33",
        value: cutStandardDisplay?.standard || "",
        top: "11.50cm",
        left: "4.62cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "15.93cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement34",
        value: dateTimeDisplay(cutProgress?.date) || "",
        top: "12.23cm",
        left: "3.84cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.99cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement35",
        value: cutProgress?.operator || "",
        top: "12.22cm",
        left: "10.47cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "3.18cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement36",
        value: cutProgress?.equipment || "",
        top: "12.23cm",
        left: "17.34cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "3.20cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement37",
        value: dateTimeDisplay(cutProgress?.completedDate) || "",
        top: "12.93cm",
        left: "4.31cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.54cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement39",
        value: cutProgress?.inspector || "",
        top: "12.94cm",
        left: "17.33cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "3.18cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement40",
        value: numberFormatAsString(
          cutProgress?.printPaperAmount?.toString() || "",
        ),
        top: "13.59cm",
        left: "3.66cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.20cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement41",
        value: numberFormatAsString(cutProgress?.amount?.toString() || ""),
        top: "13.63cm",
        left: "9.74cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.20cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement44",
        value: numberFormatAsString(
          cutProgress?.lossPercent?.toString() || "",
          {
            decimalScale: 2,
          },
        ),
        top: "14.28cm",
        left: "18.92cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "1.11cm",
        textWrap: "nowrap",
        textAlight: "center",
      },
      {
        name: "newElement45",
        value: numberFormatAsString(
          cutProgress?.printPaperCompletedAmount?.toString() || "",
        ),
        top: "14.30cm",
        left: "3.29cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.38cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement46",
        value: numberFormatAsString(
          cutProgress?.completedAmount?.toString() || "",
        ),
        top: "14.34cm",
        left: "9.66cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.17cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement47",
        value: numberFormatAsString(cutProgress?.lossAmount?.toString() || ""),
        top: "14.30cm",
        left: "14.78cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "1.85cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement48",
        value: cutStandardDisplay?.note || "",
        top: "15.03cm",
        left: "2.70cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "17.81cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement49",
        value: pasteStandardDisplay?.standard || "",
        top: "16.55cm",
        left: "4.62cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "15.93cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement50",
        value: dateTimeDisplay(pasteProgress?.date) || "",
        top: "17.28cm",
        left: "3.85cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "3.04cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement51",
        value: pasteProgress?.operator || "",
        top: "17.27cm",
        left: "10.48cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "3.15cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement52",
        value: pasteProgress?.equipment || "",
        top: "17.29cm",
        left: "17.32cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "3.2cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement53",
        value: dateTimeDisplay(pasteProgress?.completedDate) || "",
        top: "17.96cm",
        left: "4.31cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.54cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement55",
        value: pasteProgress?.inspector || "",
        top: "17.96cm",
        left: "17.28cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "3.23cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement57",
        value: numberFormatAsString(pasteProgress?.amount?.toString() || ""),
        top: "18.66cm",
        left: "9.76cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.06cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement60",
        value: numberFormatAsString(
          pasteProgress?.lossPercent?.toString() || "",
          {
            decimalScale: 2,
          },
        ),
        top: "19.33cm",
        left: "18.89cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "1.3cm",
        textWrap: "nowrap",
        textAlight: "center",
      },
      {
        name: "newElement61",
        value: numberFormatAsString(
          pasteProgress?.completedAmount?.toString() || "",
        ),
        top: "19.35cm",
        left: "9.77cm",
        height: "0.79cm",
        width: "2.20cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement63",
        value: numberFormatAsString(
          pasteProgress?.lossAmount?.toString() || "",
        ),
        top: "19.35cm",
        left: "14.78cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "1.69cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement64",
        value: pasteStandardDisplay?.note || "",
        top: "20.03cm",
        left: "2.66cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "17.83cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement65",
        value: packagesStandardDisplay?.standard || "",
        top: "21.58cm",
        left: "4.54cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "16.03cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement66",
        value: dateTimeDisplay(packageProgress?.date) || "",
        top: "22.33cm",
        left: "3.81cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "3.04cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement67",
        value: packageProgress?.operator || "",
        top: "22.30cm",
        left: "10.44cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "3.15cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement68",
        value: packageProgress?.equipment || "",
        top: "22.31cm",
        left: "17.31cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "3.31cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement69",
        value: dateTimeDisplay(packageProgress?.completedDate) || "",
        top: "22.99cm",
        left: "4.42cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.51cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement71",
        value: packageProgress?.inspector || "",
        top: "23.01cm",
        left: "17.31cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "3.25cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement73",
        value: numberFormatAsString(packageProgress?.amount?.toString() || ""),
        top: "23.71cm",
        left: "9.82cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.09cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement77",
        value: numberFormatAsString(
          packageProgress?.completedAmount?.toString() || "",
        ),
        top: "24.40cm",
        left: "9.77cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "2.20cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement78",
        value: numberFormatAsString(
          packageProgress?.lossAmount?.toString() || "",
        ),
        top: "24.39cm",
        left: "14.90cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "1.48cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement79",
        value: numberFormatAsString(
          packageProgress?.lossPercent?.toString() || "",
          {
            decimalScale: 2,
          },
        ),
        top: "24.38cm",
        left: "18.66cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "1.48cm",
        textWrap: "nowrap",
        textAlight: "center",
      },
      {
        name: "newElement80",
        value: packagesStandardDisplay.packageProcess || "",
        top: "25.05cm",
        left: "3.83cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "4.82cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement81",
        value: numberFormatAsString(
          packageProgress?.packageNumber?.toString() || "",
        ),
        top: "25.12cm",
        left: "9.93cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "0.90cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement82",
        value: numberFormatAsString(
          packageProgress?.packageAmountPerUnit?.toString() || "",
        ),
        top: "25.11cm",
        left: "13.78cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "1.48cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement83",
        value: numberFormatAsString(
          packageProgress?.packageWeightPerUnit?.toString() || "",
          {
            decimalScale: 2,
          },
        ),
        top: "25.10cm",
        left: "18.59cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "1.43cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement84",
        value: numberFormatAsString(
          packageProgress?.packageAmount?.toString() || "",
        ),
        top: "25.75cm",
        left: "3.47cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "1.14cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement85",
        value: numberFormatAsString(
          packageProgress?.packageWeight?.toString() || "",
        ),
        top: "25.74cm",
        left: "8.32cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "1.22cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement86",
        value: numberFormatAsString(
          packageProgress?.packageAmount2?.toString() || "",
        ),
        top: "25.78cm",
        left: "13.85cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "0.95cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement87",
        value: numberFormatAsString(
          packageProgress?.packageWeight2?.toString() || "",
          {
            decimalScale: 2,
          },
        ),
        top: "25.74cm",
        left: "18.69cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "1.32cm",
        textWrap: "nowrap",
      },
      {
        name: "newElement88",
        value: packagesStandardDisplay?.note || "",
        top: "26.50cm",
        left: "2.61cm",
        fontSize: "16px",
        height: "0.79cm",
        width: "17.91cm",
        textWrap: "nowrap",
      },
    ];
    return elements.map((element) => ({
      ...element,
      fontWeight: TEXT_PRINT_FONT_WEIGHT,
      textColor: TEXT_PRINT_COLOR,
    }));
  }, [
    cutProgress?.amount,
    cutProgress?.completedAmount,
    cutProgress?.completedDate,
    cutProgress?.date,
    cutProgress?.equipment,
    cutProgress?.inspector,
    cutProgress?.lossAmount,
    cutProgress?.lossPercent,
    cutProgress?.operator,
    cutProgress?.printPaperAmount,
    cutProgress?.printPaperCompletedAmount,
    cutStandardDisplay?.note,
    cutStandardDisplay?.standard,
    foilProgress?.amount,
    foilProgress?.completedAmount,
    foilProgress?.completedDate,
    foilProgress?.date,
    foilProgress?.equipment,
    foilProgress?.inspector,
    foilProgress?.lossAmount,
    foilProgress?.lossPercent,
    foilProgress?.operator,
    foilProgress?.printPaperAmount,
    foilProgress?.printPaperCompletedAmount,
    foilStandardDisplay?.note,
    foilStandardDisplay?.standard,
    packageProgress?.amount,
    packageProgress?.completedAmount,
    packageProgress?.completedDate,
    packageProgress?.date,
    packageProgress?.equipment,
    packageProgress?.inspector,
    packageProgress?.lossAmount,
    packageProgress?.lossPercent,
    packageProgress?.operator,
    packageProgress?.packageAmount,
    packageProgress?.packageAmount2,
    packageProgress?.packageAmountPerUnit,
    packageProgress?.packageNumber,
    packageProgress?.packageWeight,
    packageProgress?.packageWeight2,
    packageProgress?.packageWeightPerUnit,
    packagesStandardDisplay?.note,
    packagesStandardDisplay.packageProcess,
    packagesStandardDisplay?.standard,
    pasteProgress?.amount,
    pasteProgress?.completedAmount,
    pasteProgress?.completedDate,
    pasteProgress?.date,
    pasteProgress?.equipment,
    pasteProgress?.inspector,
    pasteProgress?.lossAmount,
    pasteProgress?.lossPercent,
    pasteProgress?.operator,
    pasteStandardDisplay?.note,
    pasteStandardDisplay?.standard,
    shapeProgress?.amount,
    shapeProgress?.completedAmount,
    shapeProgress?.completedDate,
    shapeProgress?.date,
    shapeProgress?.equipment,
    shapeProgress?.inspector,
    shapeProgress?.lossAmount,
    shapeProgress?.lossPercent,
    shapeProgress?.operator,
    shapeProgress?.printPaperAmount,
    shapeProgress?.printPaperCompletedAmount,
    shapeStandardDisplay?.note,
    shapeStandardDisplay?.standard,
  ]);
  return { backPage2Elements };
};
